import { Component, Inject, OnInit } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { Router } from '@angular/router';
import {
  AppSettings,
  CanPipe,
  ClientEnvironment,
  ENVIRONMENT,
  SystemPreferencesService,
  TagsDataConfig,
  ValueListsService,
  accessAsset,
  anyGlobal,
} from '@thehubz/client/core';

import { Tags, TagsWithAssetCount } from '@thehubz/client/data-access-api';
import { CustomClients } from '@thehubz/shared/branding';
import { AnyType, AssetMetadata } from '@thehubz/shared/model';
import { Subscription } from 'rxjs';
import { TagsDialogComponent } from '../../tags-dialog/tags-dialog.component';

@Component({
  selector: 'thehubz-asset-dashboard-keywords',
  templateUrl: './asset-dashboard-keywords.component.html',
  styleUrls: ['./asset-dashboard-keywords.component.scss'],
})
export class AssetDashboardKeywordsComponent implements OnInit {
  keywordData: AnyType[] = [];
  tagSub?: Subscription;
  editFlag = false;
  customFormInvalidCheck!: boolean;
  keywordDataLoaded = false;
  /** Tags for chip display */
  tags: string[] = [];
  /** Auto complete tag data */
  autoCompTags: Tags[] = [];
  accessCheck = false;
  saveProcess = false;
  httpCallInProgress = false;

  brandingKey!: CustomClients;
  CustomClients = CustomClients;

  tagsDialogRef!: MatDialogRef<TagsDialogComponent, TagsWithAssetCount[]>;

  AnyGlobal = anyGlobal;
  AccessAsset = accessAsset;

  constructor(
    private router: Router,
    protected canPipe: CanPipe,
    private dialog: MatDialog,
    private systemPreferencesService: SystemPreferencesService,
    private valueListsService: ValueListsService,
    @Inject(ENVIRONMENT) env: ClientEnvironment,
  ) {
    this.brandingKey = env.brandingKey ?? CustomClients.Standard;
  }

  ngOnInit(): void {
    this._showLoader();
    this.getSystemPreference();
  }

  async getSystemPreference() {
    const data = await this.systemPreferencesService.getUserPreferences();
    const keywordData = data.dashboardKeywords || [];
    this.fetchKeywordData(keywordData);
  }

  async fetchKeywordData(keywords: string[]) {
    this.keywordData = [];
    if (keywords.length > 0) {
      this.keywordData = await this.valueListsService.listTags(keywords, true);
      this._showLoader(false);
      this.keywordDataLoaded = true;
    } else {
      this._showLoader(false);
      this.keywordDataLoaded = true;
    }
  }

  clickOnChip(chipValue: { _id: string; name: string }) {
    const assetTagFilterObj: AnyType = {
      filters: {
        tags: {
          $all: [chipValue._id],
        },
      },
      sort: {
        createdAt: -1,
      },
      limit: 48,
      skip: 0,
      selectedFilterData: {
        tags: [chipValue],
      },
      searchedText: '',
    };
    sessionStorage.setItem(AppSettings.ASSET_FILTER_STRING, JSON.stringify(assetTagFilterObj));
    this.router.navigate(['assets']);
  }

  async editInformation() {
    this.tagsDialogRef = this.dialog.open<TagsDialogComponent, TagsDataConfig>(TagsDialogComponent, {
      width: '70%',
      height: '62%',
      data: {
        selectedTags: JSON.parse(JSON.stringify(this.keywordData)),
        filters: {},
        callFrom: 'dashboard',
      },
    });
    this.tagsDialogRef.disableClose = true;
    this.tagsDialogRef.afterClosed().subscribe(async (tags) => {
      if (Array.isArray(tags)) {
        const tagsList: string[] = [];
        if (tags.length) {
          tags.forEach((tag) => {
            tagsList.push(tag._id);
          });
        }
        this.systemPreferencesService.updateUserPreferences({ brandingKey: this.brandingKey, dashboardKeywords: tagsList }, AssetMetadata.General.TAGS);
        setTimeout(() => {
          this.getSystemPreference();
        }, 100);
      }
    });
  }

  /**
   * Utility method to show/hide loader
   */
  private _showLoader(show = true) {
    this.httpCallInProgress = show;
  }
}
